import { useEffect, useState } from "react";
import { InsightsInstallModal } from "../InsightsInstallModal";

export function RevenueBySegmentLockView() {
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <InsightsInstallModal open={isModalOpen} onOpenChange={setIsModalOpen} />
  );
}
